<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">PLAN PROIZVODNJE PO DANIMA</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)"
        >
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)"
        >
        </dx-date-box>
      </div>
    </div>

    <div class="customTable nadzornaPloca dnevniPlan">
      <div id="data-grid-demo">
        <dx-data-grid
          #tablicaDnevniPlan
          id="gridContainer"
          [dataSource]="tablica"
          [showColumnLines]="true"
          [wordWrapEnabled]="true"
          noDataText="{{ poruka }}"
          keyExpr="idPlan"
          [showBorders]="false"
          [columnAutoWidth]="true"
          [columnMinWidth]="100"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onCellPrepared)="onCellPrepared($event)"
        >
          <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
            <div class="naslov">
              <h2 class="mb-0">Plan proizvodnje po danima</h2>
              <p class="mt-0">Praćenje proizvodnje po danima</p>
            </div>
            <div class="d-inline ml-15">
              <dx-button
                [disabled]="pravaZaTrenutniPogled != 2"
                icon="plus"
                hint="Dodaj plan"
                stylingMode="outlined"
                type="success"
                (click)="dodajPlanPopup()"
              >
              </dx-button>
              <dx-popup
                [width]="800"
                [height]="'auto'"
                [showTitle]="true"
                title="{{ naslov }}"
                [dragEnabled]="true"
                [closeOnOutsideClick]="false"
                [position]="{ my: 'top', at: 'top', offset: '0 104' }"
                [(visible)]="dodajPlanPopupVisible"
                (onHiding)="onPopupClosed()"
              >
                <div>
                  <div class="dx-field">
                    <div class="dx-field-value w-100">
                      <dx-select-box
                        [dataSource]="partneri"
                        displayExpr="naziv"
                        valueExpr="id"
                        [(value)]="odabraniPartner"
                        placeholder="Odaberi kupca"
                        [searchEnabled]="true"
                        [searchExpr]="['sifra', 'naziv']"
                        (onValueChanged)="odaberiPartnera($event)"
                      >
                      </dx-select-box>
                    </div>
                  </div>
                  <div class="dx-field two-columns">
                    <div class="dx-field-value w-50">
                      <dx-select-box
                        #selectBox
                        [dataSource]="sviProizvodi"
                        displayExpr="sifraNaziv"
                        valueExpr="id"
                        [(value)]="odabraniProizvod"
                        placeholder="Odaberi proizvod"
                        [searchEnabled]="true"
                        [searchExpr]="['sifra', 'naziv']"
                        (onValueChanged)="odaberiProizvod($event)"
                        [disabled]="uredjivanje"
                      >
                      </dx-select-box>
                      <p
                        *ngIf="proizvodNaAkciji"
                        class="color-green"
                        style="margin-bottom: 0"
                      >
                        Odabrani proizvod je na akciji.
                      </p>
                    </div>
                    <div class="dx-field-value w-50">
                      <dx-select-box
                        [disabled]="false"
                        [items]="linijePopup"
                        [(value)]="novaLinija"
                        placeholder="Odaberi liniju"
                        valueExpr="id"
                        displayExpr="naziv"
                        (onValueChanged)="onValueChangedLinija($event)"
                      >
                      </dx-select-box>
                    </div>
                  </div>

                  <div class="dx-field three-columns">
                    <div class="dx-field-value">
                      <dx-date-box
                        [(value)]="noviDatum"
                        pickerType="calendar"
                        displayFormat='dd.MM.yyyy.'
                        width="200"
                        (onValueChanged)="onValueChangedDatum($event)"
                      >
                      </dx-date-box>
                    </div>
                    <div class="dx-field-value">
                      <dx-number-box
                        #numberBox
                        [(value)]="kolicina"
                        placeholder="Količina max. {{ maksimumOdabraneLinije }}"
                        [disabled]="!maksimumOdabraneLinije"
                        (onValueChanged)="odaberiKolicinu($event)"
                      >
                      </dx-number-box>
                    </div>
                    <div class="dx-field-value">
                      <dx-select-box
                        [disabled]="!odabraniProizvod || !novaLinija"
                        [items]="smjenePopup"
                        [(value)]="novaSmjena"
                        placeholder="Odaberi smjenu"
                        valueExpr="id"
                        displayExpr="naziv"
                        (onValueChanged)="onValueChangedSmjena($event)"
                      >
                      </dx-select-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-value w-100">
                      <div *ngIf="radnici.length" class="odabrani-radnici">
                        <strong>Odabrani djelatnici:</strong>
                        <ul>
                          <li *ngFor="let radnik of radnici; index as i">
                            {{ radnik.djelatnici }}
                            <span class="ukloni" (click)="ukloniRadnika(i)"
                              >x</span
                            >
                          </li>
                        </ul>
                      </div>
                      <div>
                        <dx-select-box
                          [(value)]="odabraniDjelatnik"
                          [dataSource]="djelatnici"
                          valueExpr="name"
                          displayExpr="name"
                          placeholder="Odaberi djelatnika"
                          [searchEnabled]="true"
                          [searchExpr]="['name']"
                          (onValueChanged)="odaberiDjelatnika($event)"
                        >
                        </dx-select-box>
                        <!-- <dx-tag-box
                        [dataSource]="djelatnici"
                        displayExpr="name"
                        valueExpr="id"
                        [showSelectionControls]="true"
                        applyValueMode="instantly"
                        [searchEnabled]="true"
                        [searchExpr]="['name']"
                      >
                      </dx-tag-box> -->
                        <!-- <dx-button
                        [disabled]="!novaSmjena || !djelatnici.length"
                        stylingMode="outlined"
                        text="Dodaj sve"
                        type="success"
                        [width]="120"
                        (onClick)="dodajSveRadnike()"
                      >
                      </dx-button> -->
                      </div>
                      <div class="small-notification">
                        *Potrebno izabrati liniju, datum i smjenu za prikaz
                        povezanih djelatnika
                      </div>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-value w-100">
                      <dx-text-area
                        placeholder="Napomena"
                        [(value)]="napomena"
                        (onValueChanged)="onValueChangedNapomena($event)"
                      >
                      </dx-text-area>
                    </div>
                  </div>
                  <div class="provjeriPolovicne" *ngIf="postojiPolovicnaPaleta">
                    <dx-check-box
                      class="mb-5 p-nadopuni"
                      text="Postoji polovična paleta! Želite li nadopuniti?"
                      [value]="nadopuni"
                      (onValueChanged)="nadopuniPaletu($event)"
                    >
                    </dx-check-box>
                    <!-- <dx-radio-group
                    *ngIf="nadopuni"
                    [items]="polovicnePalete"
                    [value]="polovicnePalete[0]"
                    displayExpr="prikaz"
                    (onValueChanged)="nadopuniPlan($event)"
                  >
                  </dx-radio-group> -->
                    <dx-select-box
                      *ngIf="nadopuni"
                      class="mb-15"
                      [items]="polovicnePalete"
                      [value]="polovicnePalete[0]"
                      valueExpr="idPlan"
                      displayExpr="prikaz"
                      (onValueChanged)="nadopuniPlan($event)"
                    ></dx-select-box>
                  </div>
                  <div *ngIf="poruka" class="dx-field error-message">
                    {{ errorMessage }}
                  </div>
                  <div class="dx-field float-right">
                    <dx-button
                      *ngIf="!uredjivanje"
                      [disabled]="disabledDodaj"
                      stylingMode="contained"
                      text="Dodaj"
                      type="success"
                      [width]="120"
                      (onClick)="dodajPlan()"
                    >
                    </dx-button>
                    <dx-button
                      *ngIf="uredjivanje"
                      stylingMode="contained"
                      text="Uredi"
                      type="success"
                      [width]="120"
                      (onClick)="urediPlan()"
                    >
                    </dx-button>
                  </div>
                </div>
              </dx-popup>

              <dx-popup
                [width]="500"
                [height]="'auto'"
                [showTitle]="true"
                title="Nedostaju sirovine"
                [dragEnabled]="false"
                [showCloseButton]="true"
                [(visible)]="nedostajuStavkePopup"
                [closeOnOutsideClick]="false">
                <div class="dx-field">
                  <dx-data-grid
                    [dataSource]="nedostajuStavkeArray"
                    [wordWrapEnabled]="true"
                    [showColumnLines]="true"
                    [showBorders]="false">
                    <dxi-column dataField="ar_naziv" caption="Naziv"></dxi-column>
                    <dxi-column dataField="nedostaje" caption="Količina"></dxi-column>
                  </dx-data-grid>
                </div>
                <div class="dx-field float-right">
                  <dx-button
                    stylingMode="contained"
                    text="Uredu"
                    type="success"
                    [width]="120"
                    (onClick)="zatvoriPopup_nedostajuStavke()">
                  </dx-button>
                </div>
              </dx-popup>

            </div>
          </div>

          <!-- Promjena smjene -->
          <div *dxTemplate="let data of 'odabirSmjene'">
            <div class="selectDropdown">
              <span>Smjena</span>
              <dx-select-box
                [disabled]="false"
                [items]="smjene"
                [value]="smjene[0].id"
                valueExpr="id"
                displayExpr="naziv"
                [width]="60"
                (onValueChanged)="promjenaSmjene($event)"
              >
              </dx-select-box>
            </div>
          </div>
          <!-- Promjena linije -->
          <div *dxTemplate="let data of 'odabirLinije'">
            <div class="selectDropdown">
              <span>Linija</span>
              <dx-select-box
                [disabled]="false"
                [items]="linije"
                [value]="linije[0].id"
                valueExpr="id"
                displayExpr="naziv"
                [width]="250"
                (onValueChanged)="promjenaLinije($event)"
              >
              </dx-select-box>
            </div>
          </div>

          <dxo-scrolling
            columnRenderingMode="virtual"
            [showScrollbar]="'always'"
          ></dxo-scrolling>

          <dxo-search-panel
            [visible]="true"
            [width]="210"
            placeholder="Pretraži..."
          >
          </dxo-search-panel>

          <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

          <dxo-pager
            [showPageSizeSelector]="true"
            [allowedPageSizes]="[10, 20, 30]"
            [showInfo]="true"
          >
          </dxo-pager>

          <dxi-column
            dataField="idPlan"
            caption="Plan"
            [width]="100"
            alignment="center"
          ></dxi-column>
          <dxi-column
            dataField="datum"
            caption="Datum"
            [width]="150"
            alignment="center"
          ></dxi-column>
          <dxi-column
            dataField="sifra"
            caption="Šifra"
            [width]="100"
            alignment="center"
          ></dxi-column>
          <dxi-column
            dataField="naziv"
            caption="Proizvod"
            [minWidth]="300"
          ></dxi-column>
          <dxi-column
            dataField="kolicina"
            caption="Količina"
            [width]="100"
            alignment="center"
          ></dxi-column>
          <dxi-column
            dataField="smjena"
            caption="Smjena"
            [width]="80"
            alignment="center"
          ></dxi-column>
          <dxi-column
            dataField="linijaNaziv"
            caption="Linija"
            [width]="300"
          ></dxi-column>
          <dxi-column dataField="idProizvoda" [visible]="false"></dxi-column>
          <dxi-column
            dataField="partner"
            caption="Kupac"
            [minWidth]="180"
          ></dxi-column>
          <dxi-column dataField="napomena"></dxi-column>
          <dxi-column cellTemplate="uredjivanje" [width]="110" alignment="center" [fixed]="true" fixedPosition="right">
            <div *dxTemplate="let data of 'uredjivanje'">
              <dx-button icon="edit" (onClick)="urediPlanPopup(data)">
              </dx-button>
              <dx-button
                *ngIf="data.data.idRNalog === null"
                icon="trash"
                hint="Obriši plan"
                (onClick)="brisanjePlanaPopup(data)"
              >
              </dx-button>
              <dx-button
                *ngIf="data.data.idRNalog != null"
                icon="trash"
                disabled="true"
                [elementAttr]="{ class: 'add-hint' }"
                hint="Za ovaj plan postoji radni nalog te ga nije moguće brisati!"
              >
              </dx-button>
            </div>
          </dxi-column>
        </dx-data-grid>
      </div>
    </div>
  </div>

  <dx-popup
    [width]="300"
    [height]="'auto'"
    [showTitle]="true"
    title="Obriši plan"
    [dragEnabled]="false"
    [closeOnOutsideClick]="true"
    [(visible)]="obrisiPlanPopupVisible"
  >
    <div>
      <!-- <div class="dx-field">
            <p>ID plan: {{idBrisanje}}</p>
        </div> -->
      <div class="dx-field field-buttons">
        <dx-button
          text="DA"
          type="danger"
          stylingMode="outlined"
          (onClick)="obrisiPlan()"
        ></dx-button>
        <dx-button
          text="Otkaži"
          type="normal"
          stylingMode="outlined"
          (onClick)="obrisiPlanPopupVisible = false"
        ></dx-button>
      </div>
    </div>
  </dx-popup>
</div>
